<template>
  <div class="container">
    <md-card class="dash-content">
      <PageHeader title="Offers Management" />

      <!-- Offers Table -->
      <div class="loader" v-if="loading || updating">
        <Wave width="50px" color="#d9534f" />
      </div>

      <md-table
        v-model="offers.mdData"
        md-card
        md-sort="created_at"
        md-sort-order="desc"
      >
        <md-table-toolbar class="mb-4">
          <div class="">
            <md-menu md-size="medium" md-align-trigger>
              <md-button
                disabled
                md-menu-trigger
                class="md-primary button-icon"
              >
                Filter
                <img src="@/assets/svg/filter.svg" />
              </md-button>

              <md-menu-content> </md-menu-content>
            </md-menu>
          </div>
        </md-table-toolbar>

        <md-table-empty-state
          v-if="offers.mdData.length < 1 && !loading"
          md-label="No offers found"
          md-description="No offers have been recorded yet or none match your current filter."
        >
          <md-button class="md-primary md-raised" @click="getOffers"
            >Refresh</md-button
          >
        </md-table-empty-state>

        <md-table-row slot="md-table-row" slot-scope="{ item, index }">
          <md-table-cell md-label="S/N" class="text-start">{{
            index + 1
          }}</md-table-cell>

          <md-table-cell md-label="Company Details">
            <div class="summary-grid">
              <div class="summary-item">
                <div class="value">{{ item?.offerable?.company_name }}</div>
                <div class="contact-info">
                  <small>Phone: {{ item?.offerable?.phone }}</small>
                </div>
              </div>
            </div>
          </md-table-cell>

          <md-table-cell md-label="Message">{{ item.message }}</md-table-cell>

          <md-table-cell md-label="Services">{{
            JSON.parse(item?.services || "[]").join(", ")
          }}</md-table-cell>

          <md-table-cell md-label="Status">
            <div class="badge" :class="item.status">
              {{ item.status }}
            </div>
          </md-table-cell>

          <md-table-cell md-label="Created Date">{{
            item.created_at | formatDate
          }}</md-table-cell>

          <md-table-cell md-label="Actions">
            <md-button
              class="md-button md-primary md-icon-button md-dense md-raised"
              @click="viewConversation(item.conversation)"
              v-if="item.conversation"
              title="View Conversation"
            >
              <md-icon>chat</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>

      <span v-if="loading" class="b-loading">Loading offers...</span>
      <pagination
        v-model="offers.mdPage"
        :records="offers.mdCount"
        :per-page="offers.mdPerPage"
        @paginate="updatePagination"
      />
    </md-card>
  </div>
</template>

<script>
import { PageHeader, Wave } from "@/components";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("offer");

export default {
  name: "Offers",
  components: {
    PageHeader,
    Wave
  },
  data: () => ({
    search: null,
    fetching: false,
    updating: false,
    exporting: false,
    time: null,
    showStatus: false,
    metadata: true,
    form: {
      offer_status: ""
    }
  }),
  watch: {
    search(val) {
      this.waitForIt(val);
    }
  },
  methods: {
    ...mapActions(["getOffers", "updateOfferStatus"]),

    async submitSearch() {
      await this.getOffers({ keyword: this.search });
    },
    async updatePagination(page) {
      let data = { page };
      if (this.search) data.keyword = this.search;
      await this.getOffer(data);
    },
    viewConversation(item) {
      this.$router.push("/offers/conversation/" + item.id);
    },

    waitForIt(val) {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => this.submitSearch(val), 1000);
    }
  },

  mounted() {
    this.getOffers({});
  },
  computed: {
    ...mapGetters(["loading", "offers"]),
    hasPermission() {
      return this.$store.getters["auth/has_module_permission"]("crud");
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}

.dash-content {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

.b-loading {
  display: block;
  text-align: center;
  margin-top: 20px;
}

.summary-grid {
  display: flex;
  flex-direction: column;
}

.summary-item {
  margin-bottom: 5px;
  max-width: 250px;
}

.value {
  font-weight: bold;
}

.contact-info {
  color: #666;
  font-size: 0.85rem;
  margin-top: 4px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.service-tag {
  background-color: #e9ecef;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
}

.message-preview {
  display: block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge {
  &.pending {
    background-color: #ffd700;
    color: #000;
  }

  &.accepted {
    background-color: #28a745;
    color: #fff;
  }

  &.rejected {
    background-color: #dc3545;
    color: #fff;
  }
}
</style>
